"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Checkbox = _interopRequireDefault(require("../inputs/Checkbox"));

var CertifiedToggle = function CertifiedToggle(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value;
  return _react.default.createElement(_Checkbox.default, {
    checked: value === true,
    name: "certified",
    onChange: function onChange(_ref2) {
      var checked = _ref2.target.checked;
      return _onChange(checked);
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.storefront.filters.certified.item"
  }));
};

CertifiedToggle.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.bool
};
var _default = CertifiedToggle;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/CertifiedToggle.js
// module id = 727
// module chunks = 209 210 211 212